import { FilterGroupUpdateCallback } from 'data/template/template.types';
import { useFieldCreateNewFilterGroup } from './useFieldCreateNewFilterGroup';

// eslint-disable-next-line import/prefer-default-export
export function useFieldCreateNew(
  handleFieldUpdate: FilterGroupUpdateCallback,
): [FilterGroupUpdateCallback] {
  const [handleFieldNewFilterGroupId] = useFieldCreateNewFilterGroup(handleFieldUpdate);

  const handleFieldCreateNew: FilterGroupUpdateCallback = (param) => {
    const { name } = param;
    if (name === 'fgId') {
      handleFieldNewFilterGroupId(param);
    }
  };

  return [handleFieldCreateNew];
}
